import { Reducer } from 'redux';
import {
  ICSPAssessQuestionnaireListItem,
  IDAQuestionnaireListItem,
  IPlanCardContent,
} from '../../../models/DashboardModels';
import {
  DevOpsAnalyticsAction,
  DevOpsAnalyticsActionTypes,
} from '../../actions/WebAnalytics/DevopsAnalytics';
import IDevOpsAnalytics, {
  IAssessmentQuestionsResponse,
  IAssessmentResponse,
  ICloudHealthDataResponse,
  IDevopsDataResponse,
  IGovAnalysisDataResponse,
  IGovDataType,
} from '../../state/DevOpsAnalyticsState';

export const initialState: IDevOpsAnalytics = {
  error: '',
  loading: false,
  toggleAssessmentUpload: false,
  governanceAnalysis: {
    financialGovernance: {
      barChart: [],
      spiderChart: [],
    },
    operationalGovernance: {
      barChart: [],
      spiderChart: [],
    },
    strategicGovernance: {
      barChart: [],
      spiderChart: [],
    },
  },
  cloudHealthAnalysis: {
    architectedFramework: {
      barChart: [],
      spiderChart: [],
    },
    additionalFramework: {
      barChart: [],
      spiderChart: [],
    },
    toolingAutomation: {
      barChart: [],
      spiderChart: [],
    },
  },
  governanceAssessmentAnalysis: {
    barChart: [],
    spiderChart: [],
  },
  devOpAnalysisData: {
    capabilityAnalysis: [],
    prioritizationMatrix: [],
  },
  devOpAssessmentAnalysisData: {
    capabilityAnalysis: [],
    prioritizationMatrix: [],
  },
  assessmentQuestions: [] as IAssessmentQuestionsResponse[],
  assessmentResp: {} as IAssessmentResponse,
  discAssessQuestionnaireListLoading: false,
  discAssessQuestionnaireList: [] as IDAQuestionnaireListItem[],
  saveUpdateAnswersLoading: false,
  saveUpdateAnswersSuccessfull: false,
  cspAssessQuestionnaireListLoading: false,
  cspAssessQuestionnaireList: [] as ICSPAssessQuestionnaireListItem[],
  saveCspAssessAnswersLoading: false,
  planCapabilityListLoading: false,
  planCapabilityList: [] as IPlanCardContent[],
};

export const DevOpsAnalyticsReducer: Reducer<IDevOpsAnalytics> = (
  state = initialState,
  action: DevOpsAnalyticsAction,
) => {
  switch (action.type) {
    case DevOpsAnalyticsActionTypes.GET_ANALYTICS_ASSESSMENT_START:
      return {
        ...state,
        loading: true,
      };
    case DevOpsAnalyticsActionTypes.GET_ANALYTICS_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        devOpAnalysisData: action.data as IDevopsDataResponse,
      };
    case DevOpsAnalyticsActionTypes.GET_ANALYTICS_ASSESSMENT_ERROR:
      return {
        ...state,
        loading: false,
      };
    case DevOpsAnalyticsActionTypes.GET_ASSESSMENT_QUESTIONS_START:
      return {
        ...state,
        loading: true,
      };
    case DevOpsAnalyticsActionTypes.GET_ASSESSMENT_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        assessmentQuestions: action.data as IAssessmentQuestionsResponse[],
      };
    case DevOpsAnalyticsActionTypes.GET_ASSESSMENT_QUESTIONS_ERROR:
      return {
        ...state,
        loading: false,
      };
    case DevOpsAnalyticsActionTypes.GET_GOVERNANCE_ASSESSMENT_START:
      return {
        ...state,
        loading: true,
      };
    case DevOpsAnalyticsActionTypes.GET_GOVERNANCE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        governanceAnalysis: action.data as IGovAnalysisDataResponse,
      };
    case DevOpsAnalyticsActionTypes.GET_GOVERNANCE_ASSESSMENT_ERROR:
      return {
        ...state,
        loading: false,
      };

    case DevOpsAnalyticsActionTypes.GET_BUILD_DEPLOY_ASSESSMENT_START:
      return {
        ...state,
        loading: true,
      };
    case DevOpsAnalyticsActionTypes.GET_BUILD_DEPLOY_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        cloudHealthAnalysis: action.data as ICloudHealthDataResponse,
      };
    case DevOpsAnalyticsActionTypes.GET_BUILD_DEPLOY_ASSESSMENT_ERROR:
      return {
        ...state,
        loading: false,
      };

    case DevOpsAnalyticsActionTypes.GET_SECURITY_ASSESSMENT_GRAPH_DATA_START:
      return {
        ...state,
        loading: true,
      };
    case DevOpsAnalyticsActionTypes.GET_SECURITY_ASSESSMENT_GRAPH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        governanceAssessmentAnalysis: action.data as IGovDataType,
      };
    case DevOpsAnalyticsActionTypes.GET_SECURITY_ASSESSMENT_GRAPH_DATA_ERROR:
      return {
        ...state,
        loading: false,
      };

    case DevOpsAnalyticsActionTypes.POST_GOVERNANCE_ASSESSMENT_START:
      return {
        ...state,
        loading: true,
      };
    case DevOpsAnalyticsActionTypes.POST_GOVERNANCE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        toggleAssessmentUpload: !state.toggleAssessmentUpload,
      };
    case DevOpsAnalyticsActionTypes.POST_GOVERNANCE_ASSESSMENT_ERROR:
      return {
        ...state,
        loading: false,
      };
    case DevOpsAnalyticsActionTypes.SET_ASSESSMENT_RESULT_START:
      return {
        ...state,
        loading: true,
      };
    case DevOpsAnalyticsActionTypes.SET_ASSESSMENT_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DevOpsAnalyticsActionTypes.SET_ASSESSMENT_RESULT_ERROR:
      return {
        ...state,
        loading: false,
      };

    case DevOpsAnalyticsActionTypes.GET_DISCOVER_ASSESSMENT_GRAPH_START:
      return {
        ...state,
        loading: true,
      };
    case DevOpsAnalyticsActionTypes.GET_DISCOVER_ASSESSMENT_GRAPH_SUCCESS:
      return {
        ...state,
        loading: false,
        devOpAssessmentAnalysisData: action.data as IDevopsDataResponse,
      };
    case DevOpsAnalyticsActionTypes.GET_DISCOVER_ASSESSMENT_GRAPH_ERROR:
      return {
        ...state,
        loading: false,
      };

    case DevOpsAnalyticsActionTypes.GET_ASSESSMENT_RESPONSES_START:
      return {
        ...state,
        loading: true,
      };
    case DevOpsAnalyticsActionTypes.GET_ASSESSMENT_RESPONSES_SUCCESS:
      return {
        ...state,
        loading: false,
        assessmentResp: action.data as IAssessmentResponse,
      };
    case DevOpsAnalyticsActionTypes.GET_ASSESSMENT_RESPONSES_ERROR:
      return {
        ...state,
        loading: false,
      };
    case DevOpsAnalyticsActionTypes.GET_DISCOVERY_ASS_QUESTIONS_START:
      return {
        ...state,
        discAssessQuestionnaireListLoading: true,
      };
    case DevOpsAnalyticsActionTypes.GET_DISCOVERY_ASS_QUESTIONS_SUCCESS:
      return {
        ...state,
        discAssessQuestionnaireListLoading: false,
        discAssessQuestionnaireList: action.data as IDAQuestionnaireListItem[],
      };
    case DevOpsAnalyticsActionTypes.GET_DISCOVERY_ASS_QUESTIONS_ERROR:
      return {
        ...state,
        discAssessQuestionnaireListLoading: false,
      };
    case DevOpsAnalyticsActionTypes.SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_START:
      return {
        ...state,
        saveUpdateAnswersLoading: true,
        saveUpdateAnswersSuccessfull: false,
      };
    case DevOpsAnalyticsActionTypes.SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_SUCCESS:
      return {
        ...state,
        saveUpdateAnswersLoading: false,
        saveUpdateAnswersSuccessfull: true,
      };
    case DevOpsAnalyticsActionTypes.SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_ERROR:
      return {
        ...state,
        saveUpdateAnswersLoading: false,
        saveUpdateAnswersSuccessfull: false,
      };
    case DevOpsAnalyticsActionTypes.UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_START:
      return {
        ...state,
        saveUpdateAnswersLoading: true,
        saveUpdateAnswersSuccessfull: false,
      };
    case DevOpsAnalyticsActionTypes.UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_SUCCESS:
      return {
        ...state,
        saveUpdateAnswersLoading: false,
        saveUpdateAnswersSuccessfull: true,
      };
    case DevOpsAnalyticsActionTypes.UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_ERROR:
      return {
        ...state,
        saveUpdateAnswersLoading: false,
        saveUpdateAnswersSuccessfull: false,
      };
    case DevOpsAnalyticsActionTypes.RESET_ANS_FLAG:
      return {
        ...state,
        saveUpdateAnswersSuccessfull: false,
      };
    case DevOpsAnalyticsActionTypes.GET_CSP_ASSES_QUESTIONS_START:
      return {
        ...state,
        cspAssessQuestionnaireListLoading: true,
      };
    case DevOpsAnalyticsActionTypes.GET_CSP_ASSES_QUESTIONS_SUCCESS:
      return {
        ...state,
        cspAssessQuestionnaireListLoading: false,
        cspAssessQuestionnaireList: action.data as ICSPAssessQuestionnaireListItem[],
      };
    case DevOpsAnalyticsActionTypes.GET_CSP_ASSES_QUESTIONS_ERROR:
      return {
        ...state,
        cspAssessQuestionnaireListLoading: false,
      };
    case DevOpsAnalyticsActionTypes.SUBMIT_SAVE_CSP_ASSES_QUESTIONS_START:
      return {
        ...state,
        saveCspAssessAnswersLoading: true,
      };
    case DevOpsAnalyticsActionTypes.SUBMIT_SAVE_CSP_ASSES_QUESTIONS_SUCCESS:
      return {
        ...state,
        saveCspAssessAnswersLoading: false,
      };
    case DevOpsAnalyticsActionTypes.SUBMIT_SAVE_CSP_ASSES_QUESTIONS_ERROR:
      return {
        ...state,
        saveCspAssessAnswersLoading: false,
      };
      case DevOpsAnalyticsActionTypes.GET_PLAN_CAPABILITY_LIST_START:
        return {
          ...state,
          planCapabilityListLoading: true,
          planCapabilityList: [] as IPlanCardContent[],
        };
      case DevOpsAnalyticsActionTypes.GET_PLAN_CAPABILITY_LIST_SUCCESS:
        return {
          ...state,
          planCapabilityListLoading: false,
          planCapabilityList: action.data as IPlanCardContent[],
        };
      case DevOpsAnalyticsActionTypes.GET_PLAN_CAPABILITY_LIST_ERROR:
        return {
          ...state,
          planCapabilityListLoading: false,
        };
        case DevOpsAnalyticsActionTypes.SAVE_PLAN_CAPABILITY_LIST_START:
          return {
            ...state,
            planCapabilityListLoading: true,
          };
        case DevOpsAnalyticsActionTypes.SAVE_PLAN_CAPABILITY_LIST_SUCCESS:
          return {
            ...state,
            planCapabilityListLoading: false,
          };
        case DevOpsAnalyticsActionTypes.SAVE_PLAN_CAPABILITY_LIST_ERROR:
          return {
            ...state,
            planCapabilityListLoading: false,
          };
    default:
      return state;
  }
};
